import React from "react";
import { Box } from "@mui/material";
import {
  HEADER_HEIGHT,
  SIDEBAR_MAXWIDTH,
  SIDEBAR_MINWIDTH,
} from "../../../../utils/ui.constants";
import SidebarSmall from "./sidebar-small/SidebarSmall";
import SidebarWide from "./sidebar-wide/SidebarWide";

interface ISidebar {
  expand: true | false;
}

function Sidebar({ expand }: ISidebar) {
  return (
    <Box
      sx={{
        width: expand ? SIDEBAR_MAXWIDTH : SIDEBAR_MINWIDTH,
        height: `calc(100vh - ${HEADER_HEIGHT})`,
        backgroundColor: "background.paper",
        position: "relative",
        transition: "all linear 0.1s",
        overflow: "auto",
      }}
    >
      {/* Content */}
      {expand ? <SidebarWide /> : <SidebarSmall />}
      {/* Content end */}
    </Box>
  );
}

export default Sidebar;
